import { render, staticRenderFns } from "./TaskDetailDialog.vue?vue&type=template&id=18dc3f1c&scoped=true&"
import script from "./TaskDetailDialog.vue?vue&type=script&lang=js&"
export * from "./TaskDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailDialog.vue?vue&type=style&index=0&id=18dc3f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc3f1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VIcon,VSpacer,VToolbarTitle})
